<template>
  <div class="ratio-container" :style="borderStyle">
    <span
      class="ratio-span"
      :class="{ 'checked': isChecked }"
      :style="style"
      @click="$emit('click')"
    >{{ label }}</span>
  </div>
</template>
<script>
export default {
  name: "Ratio",
  props: {
    label: {
      type: String,
      required: true,
    },
    isChecked: {
      type: Boolean,
      required: true,
    },
    isBordered: {
      type: Boolean,
      required: false,
      default: false,
    },
    onColor: {
      type: String,
      required: false,
      default: "",
    },
    offColor: {
      type: String,
      required: false,
      default: "",
    },
    borderColor: {
      type: String,
      required: false,
      default: "rgba(0, 0, 0, 0.719)",
    },
  },
  computed: {
    style() {
      return {
        color: this.isChecked ? this.onColor : this.offColor,
      };
    },
    borderStyle() {
      if (this.isBordered)
        return { border: `2px solid ${this.borderColor}` };
      else
        return { borderStyle: "none" };
    }
  }
}
</script>
<style lang="scss">
.ratio-container {
  box-sizing: border-box;
  display: block;
  padding: 0 5px;
  border-radius: 5px;
  line-height: 1.7em;

  .ratio-span {
    font-size: 1em;
    font-weight: normal;
    transition: all 200ms ease;

    &:hover {
      cursor: pointer;
    }
    &.checked, &:hover {
      font-weight: 500;
      font-size: 1.3em;
      line-height: calc(1.3em - 2px);
    }
  }
}
</style>
